import { render, staticRenderFns } from "./IdFind.vue?vue&type=template&id=30b4ab67&scoped=true"
import script from "./IdFind.vue?vue&type=script&lang=js"
export * from "./IdFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4ab67",
  null
  
)

export default component.exports